<template>
    <div v-sticky="{ isSticky: true }" class="h-100">
        <nav aria-label="Main navigation" class="h-100">
            <div class="pr--nav-right--container pb-3 pl-3 pr-3">
                <div v-if="dataIndex.data.sidebar !== null" class="h-100" style="margin-top: -1px;">
                    <!--                    <div v-if="show.pending" class="row">-->
                    <!--                        <div class="col-12 placeholder-wave mt-3 mb-3 rounded-1">-->
                    <!--                            <div class="placeholder col-12 placeholder-lg" />-->
                    <!--                            <div class="placeholder col-12 placeholder-lg" />-->
                    <!--                            <div class="placeholder col-12 placeholder-lg" />-->
                    <!--                            <div class="placeholder col-12 placeholder-lg" />-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <FrontendArticleDetailsRightPackage
                        v-if="!show.pending && article !== null"
                        :article="article"
                    />
<!--                    <FrontendArticleDetailsRightArticle-->
<!--                        v-if="!show.pending && article !== null && article.is_article"-->
<!--                        :article="article"-->
<!--                    />-->
                    <div
                        v-if="dataIndex.data.sections.right !== undefined && dataIndex.data.sections.right.articles.length"
                        class=""
                    >
                        <!--                        <div v-if="show.data !== null && show.data.options !== null && system.route.name === 'articles-id-slug'" class="col-12">-->
                        <!--                            <h5>Похожие статьи:</h5>-->
                        <!--                        </div>-->
                        <FrontendArticleCardLeft
                            v-for="(article, key) in dataIndex.data.sections.right.articles"
                            :key="key"
                            :article="article"
                            :type="'compact'"
                        />
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script setup lang="ts">
import FrontendArticleDetailsRightArticle from '@/components/Frontend/Article/Details/Right/FrontendArticleDetailsRightArticle.vue';
import FrontendArticleDetailsRightPackage from '@/components/Frontend/Article/Details/Right/FrontendArticleDetailsRightPackage.vue';
import FrontendArticleCardLeft from '@/components/Frontend/Article/FrontendArticleCardLeft.vue';
import { useStoreAppDataIndex } from '@/stores/app/data';
import { useStoreArticlesShow } from '@/stores/articles/show';

const dataIndex = useStoreAppDataIndex();
const show = useStoreArticlesShow();

defineProps<{
    article: object|null
}>();

</script>
